import { DateTime } from 'luxon';
import { GenericSearchRequest } from '../../../util/util';

export type CreateStripeAccountRequest = {
  businessEmail: string;
  businessName: string;
  userId: number;
};
export type StripeAccount = {
  userId: number;
  accountStatus: StripeAccountStatus;
  accountType: string;
  businessEmail: string;
  businessName: string;
  stripeAccountId: string;
  createdAt: DateTime;
  updatedAt: DateTime;
  missingRequirements?: string[];
};
export enum StripeAccountStatus {
  Incomplete,
  Complete,
  Pending,
}

export enum PaymentMethodStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum PaymentMethodConfigType {
  BuiltIn = 'BuiltIn',
  Custom = 'Custom',
}

export type PaymentMethodConfig = {
  id: string;
  name: string;
  displayName: string;
  description: string;
  status: PaymentMethodStatus;
  type: PaymentMethodConfigType;
  createdAt: DateTime;
  deletedAt?: DateTime;
};

export type PaymentMethodRequest = Partial<Omit<PaymentMethodConfig, 'id' | 'createdAt' | 'deletedAt'>>;

export type PaymentMethodSearchRequest = GenericSearchRequest<PaymentMethodConfig> & { includeDeleted?: boolean };
